import { render } from "./AiImageGenerator.vue?vue&type=template&id=2aa2f4dd&scoped=true"
import script from "./AiImageGenerator.vue?vue&type=script&lang=js"
export * from "./AiImageGenerator.vue?vue&type=script&lang=js"

import "./AiImageGenerator.vue?vue&type=style&index=0&id=2aa2f4dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa2f4dd"]])

export default __exports__